/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { ReactElement, useEffect, useState } from "react"
import { Layout } from "antd"
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"


import Header from "../components/Header/Header"
import Footer from "../components/Footer/Footer"
import Cookie from "../components/Cookie/Cookie"
import { ApolloClient, InMemoryCache, ApolloProvider } from "@apollo/client"

import "../assets/css/style.scss"
import "../assets/css/app.less" // for importing antd
import FindaHotel from "../components/FindaHotel/FindaHotel"
import { checkCookies } from "../utilities/check-cookies"
import Cookies from "js-cookie"
import { COOKIES } from "../enum"
import { reInitializeGA } from "../utilities/google-analytics"
import MaintenancePage from "../pages/maintenance"

const { Content } = Layout

const client = new ApolloClient({
  uri: process.env.GATSBY_API_URL,
  cache: new InMemoryCache(),
})

type LayoutPropTypes = {
  children?:
  | string
  | Element
  | ReactElement
  | boolean
  | (string | Element | ReactElement | boolean)[]
  pageContext?: any
  title: string
  isBookingLayout?: boolean
}

const layoutLanding = ({
  children,
  pageContext,
  title,
  isBookingLayout,
}: LayoutPropTypes): ReactElement => {
  const { brands, hotels, footer, aboutUsDetails } = pageContext || {
    brands: [],
    hotels: [],
    footer: [],
  }
  const cookieState = Cookies.get(COOKIES.PERFORMANCE_COOKIES)
  const [hasPerformanceCookies, setHasPerformanceCookies] = useState(false)
  const [showSideButton, setShowSideButton] = useState(true)


  const [isMaintenance, setIsMaintenance] = useState(false)

  useEffect(() => {
  // Check if the environment variable for the token exists and is not an empty string or just spaces
  if (process.env.GATSBY_TESTING_TOKEN && process.env.GATSBY_TESTING_TOKEN.trim() !== '') {
    // Attempt to get the token from localStorage
    const storedToken = localStorage.getItem('testing-token');

    if (storedToken) {
      // If a token exists in localStorage, compare it with the environment token
      if (storedToken === process.env.GATSBY_TESTING_TOKEN) {
        setIsMaintenance(false); // Token matches, exit maintenance mode
      } else {
        setIsMaintenance(true); // Token doesn't match, stay in maintenance mode
      }
    } else {
      // No token in localStorage, enter maintenance mode
      setIsMaintenance(true);

      // Check the URL for a token and handle it
      if (typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search);
        const tokenFromUrl = params.get('testing-token');

        if (tokenFromUrl === process.env.GATSBY_TESTING_TOKEN) {
          // Store the token in localStorage if it matches the environment token
          localStorage.setItem('testing-token', tokenFromUrl);

          // Clean the URL by removing the query parameter
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);

          setIsMaintenance(false); // Exit maintenance mode
        } else {
          // Clean the URL and remove the token from localStorage if it doesn't match
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);
          localStorage.removeItem('testing-token');
        }
      }
    }
  } else {
    // If the environment token is empty or whitespace, disable maintenance mode
    setIsMaintenance(false);
    localStorage.removeItem('testing-token');
  }
}, []);




  useEffect(() => {
    setHasPerformanceCookies(cookieState === "true")
  }, [setHasPerformanceCookies, Cookies, cookieState])

  useEffect(() => {
    if (hasPerformanceCookies === true) {
      reInitializeGA()
    }
  }, [hasPerformanceCookies])

  useEffect(() => {
    if (typeof window !== undefined) {
      if (
        window.location.href.indexOf("booking-confirmation") > 0 ||
        window.location.href.indexOf("booking-details") > 0
      ) {
        setShowSideButton(false)
      } else {
        setShowSideButton(true)
      }
    }
  }, [])

  useEffect(() => {
    checkCookies()
  }, [hasPerformanceCookies])

  const findHotelOpen = () => {
    if (typeof window !== "undefined") {
      const ele = document.getElementById("findhotelFullscreen")

      if (ele) document.body.style.overflow = "hidden"
      return ele?.classList.add("active")
    }
  }

  const bookNowSideButton = showSideButton ? (
    <span onClick={findHotelOpen} className="sticky-btn" id="stickyBtn">
      Book Now
    </span>
  ) : null
  return (
    <ApolloProvider client={client}>
      <Helmet>
        {/* Remove firebase.js */}
        {/* {<script type="module" src="/firebase.js"></script>} */}
        {
          <noscript>
            {`
                <img
                height="1"
                width="1"
                src="https://www.facebook.com/tr?id=860210341343925&ev=PageView
            &noscript=1"
              />`}
          </noscript>
        }
        {hasPerformanceCookies === true && (
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=UA-56517066-2"
            nonce="DhcnhD3khTMePgXw"
          ></script>
        )}
        {hasPerformanceCookies === true && (
          <script id="ga-script" nonce="DhcnhD3khTMePgXw">
            {`window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'UA-56517066-2');
          `}
          </script>
        )}
      </Helmet>
      {isMaintenance ? (
        <MaintenancePage ></MaintenancePage>
      ) : (
        <Layout className={`layout ${title}`}>
          <Header
            searchData={brands}
            siteTitle={`Title`}
            isBookingHeader={isBookingLayout}
            aboutUsData={aboutUsDetails}
          />
          <FindaHotel
            data={{
              tarsiergraphql: {
                getBrands: brands,
                getHotels: hotels,
              },
            }}
            dropdownClassName="certain-category-search-dropdown"
            placeholder="Search Hotel and Location"
            containerId="findhotelFullscreen"
            formID="formHotel2"
            bookingFormStatus={true}
          />
          {bookNowSideButton}
          <Content style={{ marginTop: isBookingLayout ? 72 : "unset" }}>
            {children}
          </Content>
          <Footer
            isBookingFooter={isBookingLayout}
            data={{
              tarsiergraphql: {
                getFooter: footer,
              },
            }}
          />
          <Cookie />
        </Layout>
      )}

    </ApolloProvider>
  )
}

export default layoutLanding
